import Repository from '../../../../../foundation/repository/Repository';
import ApiData from '../../../../../foundation/repository/ApiData';
import Organization from '../aggregates/organization/Organization';
import OrganizationType from '../aggregates/organization/OrganizationType';

export default class OrganizationRepository extends Repository<Organization> {

	public mapObject (data: ApiData) {
		return new Organization(
			data.id<Organization>('id'),
			new OrganizationType(data.string('type')),
			data.string('name')
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/organizations/domain/repositories/OrganizationRepository.ts